import React from "react";
import { Box, Typography } from "@mui/material";

// Load Poppins Font
const link = document.createElement("link");
link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

const ChildSafetyPolicy = () => {
    return (
        <Box
            sx={{
                fontFamily: "Poppins",
                maxWidth: 900,
                mx: "auto",
                p: 4,
                lineHeight: 1.6,
            }}
        >
            {/* Header */}
            <Typography fontFamily={'Poppins'} variant="h4" fontWeight={600} gutterBottom>
                Cerkle Safety Standards
            </Typography>

            {/* Commitment Section */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} gutterBottom>
                Our Commitment to Child Safety
            </Typography>
            <Typography fontFamily={'Poppins'}>
                At Cerkle, we prioritize user safety and maintain a{" "}
                <b>zero-tolerance policy</b> for child sexual abuse and exploitation (CSAE). 
                Our platform is designed to be a safe and responsible online space through 
                strict enforcement of safety policies and proactive collaboration with global authorities.
            </Typography>

            {/* Content Moderation */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} mt={3} gutterBottom>
                Content Moderation & Reporting
            </Typography>
            <Typography fontFamily={'Poppins'}>
                We use a combination of AI-driven content moderation and manual reviews 
                to detect and remove any content violating our guidelines. Our moderation team is 
                trained to identify explicit content, inappropriate behavior, and potential threats.
            </Typography>
            <Typography fontFamily={'Poppins'} mt={1}>
                If you encounter any content that violates our policies, you can report it directly
                within the app or email our safety team at <b>support@vybecerkle.com</b>. 
                All reports are reviewed promptly, and necessary actions are taken immediately.
            </Typography>

            {/* Age Restrictions */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} mt={3} gutterBottom>
                User Verification & Age Restrictions
            </Typography>
            <Typography fontFamily={'Poppins'}>
                Cerkle enforces an 18+ age restriction for user registration. 
                We implement age verification measures and AI-powered identity checks 
                to prevent underage access.
            </Typography>
            <Typography fontFamily={'Poppins'} mt={1}>
                <b>Strict Measures:</b>
                <ul>
                    <li>Users under 18 are strictly prohibited from registering.</li>
                    <li>Any misrepresentation of age will result in immediate account termination.</li>
                    <li>Repeated violations may lead to permanent bans and legal actions.</li>
                </ul>
            </Typography>

            {/* Community Guidelines */}
            <Typography variant="h6" fontFamily={'Poppins'} fontWeight={500} mt={3} gutterBottom>
                Community Guidelines & Enforcement
            </Typography>
            <Typography fontFamily={'Poppins'}>
                Our platform upholds strict community guidelines to foster a safe and respectful space. 
                We do not tolerate:
                <ul>
                    <li><b>Child exploitation or abuse</b></li>
                    <li><b>Harassment, bullying, or predatory behavior</b></li>
                    <li><b>Explicit or inappropriate content involving minors</b></li>
                    <li><b>Solicitation of minors or any harmful interactions</b></li>
                </ul>
            </Typography>
            <Typography fontFamily={'Poppins'} mt={1}>
                Any user violating these policies will face immediate action, including:
                <ul>
                    <li>Content removal</li>
                    <li>Temporary or permanent account suspension</li>
                    <li>Legal reporting to authorities if necessary</li>
                </ul>
            </Typography>

            {/* Advanced Safety Technologies */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} mt={3} gutterBottom>
                Advanced Safety & Monitoring Technologies
            </Typography>
            <Typography fontFamily={'Poppins'}>
                Cerkle employs cutting-edge AI and machine learning algorithms to detect suspicious activities 
                and block inappropriate content before it reaches users. Our system continuously scans for:
                <ul>
                    <li>Explicit images/videos and inappropriate language</li>
                    <li>Accounts engaging in suspicious activities</li>
                    <li>Users attempting to bypass safety measures</li>
                </ul>
            </Typography>
            <Typography fontFamily={'Poppins'} mt={1}>
                We also utilize automated alerts and user behavior analysis to flag potential threats in real-time.
            </Typography>

            {/* Law Enforcement Cooperation */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} mt={3} gutterBottom>
                Law Enforcement & Global Partnerships
            </Typography>
            <Typography fontFamily={'Poppins'}>
                We actively collaborate with law enforcement agencies, cybersecurity experts, and child protection organizations 
                to combat CSAE. Cerkle is committed to full legal compliance and swift action when handling cases 
                related to child safety violations.
            </Typography>
            <Typography fontFamily={'Poppins'} mt={1}>
                If you are a law enforcement officer or an organization working to protect children, 
                you can contact our legal department at <b>legal@vybecerkle.com</b> for assistance.
            </Typography>

            {/* Contact Information */}
            <Typography fontFamily={'Poppins'} variant="h6" fontWeight={500} mt={3} gutterBottom>
                Contact Information
            </Typography>
            <Typography fontFamily={'Poppins'}>
                For general support, reporting concerns, or further information, please reach out to:
                <ul>
                    <li><b>Support:</b> <a href="mailto:support@vybecerkle.com">support@vybecerkle.com</a></li>
                    <li><b>Legal Inquiries:</b> <a href="mailto:legal@vybecerkle.com">legal@vybecerkle.com</a></li>
                </ul>
            </Typography>

            {/* Closing Statement */}
            <Typography fontWeight={600} mt={3} fontFamily={'Poppins'}>
                Cerkle remains dedicated to creating a safe, secure, and responsible platform for all users.
            </Typography>
        </Box>
    );
};

export default ChildSafetyPolicy;
